import {
  Button,
  Dialog,
  Flex,
  Text,
  TextInput,
  TextInputProps,
  createForm,
} from '@applyboard/crystal-ui'
import { ComponentType } from 'react'

type OtpVerificationDialogProps = {
  open: boolean
  loading: boolean
  newEmail: string
  onOpenChange: (open: boolean) => void
  onSubmit: (oneTimePass: string) => void
}

const { Form: NewEmailOtpForm, Field: NewEmailOtpField } = createForm<{ oneTimePass: string }>()

export function NewEmailOtpDialog(props: OtpVerificationDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Heading>
        <Flex direction="column" gap={0}>
          <Text variant="labelS">STEP 3/3</Text>
          <Text variant="titleM">Verify your new email</Text>
        </Flex>
      </Dialog.Heading>
      <Dialog.Content>
        <Flex direction="column" gap={4}>
          <Text>
            Enter the one-time passcode sent to your <strong>new</strong> email address:{' '}
            <strong>{props.newEmail}</strong>.
          </Text>
          <NewEmailOtpForm
            defaultValues={{ oneTimePass: '' }}
            onSubmit={data => props.onSubmit(data.oneTimePass)}
            id="new-email-otp-form"
          >
            <NewEmailOtpField
              as={TextInput as ComponentType<TextInputProps>}
              label="One-time passcode"
              name="oneTimePass"
              validate={otp => {
                if (!otp) {
                  return 'Please enter the passcode.'
                }
                return true
              }}
            />
          </NewEmailOtpForm>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <Button
          intent="primary"
          width="fill"
          type="submit"
          form="new-email-otp-form"
          loading={props.loading}
        >
          Verify
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}
